import {SkeletonBlock, SPACING} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';

const TERM_WIDTHS = ['55%', '40%', '65%', '35%', '50%'] as const;
const ICON_SIZE = '18px';

// Restates the geometry of the ui-components suggestion row instead of
// rendering it: this is the lazy fallback of the typed-search panel, so
// everything it imports lands in the eager bundle of every page.
export const SearchSuggestionsSkeleton: FC = () => (
  <div data-testid="searchSuggestionsLoading" aria-hidden="true">
    {TERM_WIDTHS.map((width, index) => (
      <Row key={`search-suggestion-skeleton-${index}`}>
        <SkeletonBlock
          $width={ICON_SIZE}
          $height={ICON_SIZE}
          disableSpaceBelow
        />
        <SkeletonBlock $width={width} $height="14px" disableSpaceBelow />
      </Row>
    ))}
  </div>
);

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING['X.Sm']};
  padding: clamp(0.5rem, 1vh, 0.8rem) 0.6rem;
`;
